<style scoped>
#lottie {
  position: absolute;
  display: block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30px;
}

</style>
<template>
  <transition name="fade" mode="out-in" appear>
    <div id="lottie"></div>
  </transition>
</template>
<script>
import lottie from "lottie-web"
import animationData from "./lottie.json"
export default {
  data() {
    return {
      showFlag: false,
    }
  },
  mounted() {
    this.startAnim();
  },
  methods: {
    startAnim() {
      console.log("开始动画");
      let params = {
        container: document.getElementById("lottie"),
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: animationData,
      };
      let anim= lottie.loadAnimation(params);
    },
    hide() {
      this.showFlag = false;
    },
    show() {
      this.showFlag = true;
    }
  }
}
</script>
